import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SelectionBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  justify-content: flex-start;
  width: 100%;
  margin-bottom: ${Spacing.S12};
`
